import { render } from "./companyForm.vue?vue&type=template&id=2fb4b0a2&scoped=true&ts=true"
import script from "./companyForm.vue?vue&type=script&lang=ts"
export * from "./companyForm.vue?vue&type=script&lang=ts"

import "./companyForm.vue?vue&type=style&index=0&id=2fb4b0a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb4b0a2"]])

export default __exports__